import React from "react";
import { Tabs } from "antd";
import { Box, Image, Button } from "../../../helbest";
import ImgProduct from "../../../assets/images/base/product.png";

const { TabPane } = Tabs;

const DeliveryItem = () => {
  // eslint-disable-next-line
  const TabsComponentRender = () => {
    return (
      <Tabs type="card">
        {[{ is_active: true }, { is_active: false }, { is_active: true }].map(
          (date, index) => (
            <TabPane
              tab={
                <div className="delivery-item-tab-title">
                  <h4
                    className={
                      !date.is_active || date.is_holiday ? "holiday" : ""
                    }
                  >
                    {date.display_name}
                  </h4>
                  <p
                    className={
                      !date.is_active || date.is_holiday ? "holiday" : ""
                    }
                  >
                    {date.display_date}
                  </p>
                </div>
              }
              key={index}
            >
              {date.is_active ? (
                <div className="delivery-item-tab-content">
                  {date.shifts?.map((shift, i) => (
                    <label key={i} className="radio-input no-mr radio-ml">
                      <input
                        value={shift.value}
                        type="radio"
                        name={`diop`}
                        defaultChecked={index === 0 && i === 0}
                      />
                      <span className="checkmark"></span>
                      {shift.name}
                    </label>
                  ))}
                </div>
              ) : (
                <div className="delivery-item-tab-content">
                  <label
                    className={!date.is_active || date.holiday ? "holiday" : ""}
                  >
                    {date.holiday}
                  </label>
                </div>
              )}
            </TabPane>
          )
        )}
      </Tabs>
    );
  };

  return (
    <Box className="component-delivery-item">
      <div className="w-100">
        <span className="text-green">شیوه تحویل : </span> خدمات در مراکز
      </div>

      <div className="ws-100">
        <span> نام محصول</span>
        <Image src={ImgProduct} alt="p" />
      </div>

      <div className="component-delivery-item-line-break mt-2"></div>

      <div className="ws-100 mt-2">
        <p className="light-text">
          لطفا نزدیک ترین مرکزخدمات به خود را انتخاب کنید.
        </p>
        <Button className="button-select">انتخاب مرکز</Button>
      </div>
    </Box>
  );
};

export default DeliveryItem;
